import formatPercent from './formatPercent';
export default formatPercent;